import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { signInWithPopup, signInWithRedirect } from 'firebase/auth';
import { auth, googleProvider } from '../../firebase';
import { saveUserToFirestore } from '../../utils/firestoreUser';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './LandingPage.css';

function LandingPage() {
    const navigate = useNavigate();

    const handleGoogleSignIn = async () => {
        try {
            // Try popup first
            console.log('Attempting popup authentication');
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;
            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
                navigate('/home');
            } else {
                await saveUserToFirestore(user);
                navigate('/first-profile');
            }
        } catch (error) {
            console.error("Popup failed, trying redirect:", error);
            
            // If popup fails, try redirect
            try {
                await signInWithRedirect(auth, googleProvider);
            } catch (redirectError) {
                console.error("Both popup and redirect failed:", redirectError);
                alert('שגיאה בהתחברות. אנא נסה שוב או פנה לתמיכה.');
            }
        }
    };

    return (
        <div
            className="landing-page"
            style={{
                backgroundImage: "url('/background.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                minHeight: "100vh",
            }}
        >
            <header className="header">
                <h1 className="main-title display-4 mb-3">
                    <img src="/logo2.png" alt="Shabbat Abroad Logo" className="logo" />
                    <span className="title-text">Shabbat Abroad</span>
                </h1>
            </header>
            <p className="lead subtitle">
                Shabbat Abroad is your community gateway to Friday night dinners around the world. Whether you're traveling, studying, or local, you can find welcoming hosts or open your table to new friends. Join us and experience the warmth and connection of global Jewish hospitality.
            </p>
            <Container fluid className="text-center">
                <Row className="mb-5 justify-content-center">
                    <Col md={12} className="text-center">
                        {/* header and subtitle now above */}
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col md={12} className="text-center">
                        <Button
                            variant="light"
                            size="lg"
                            className="google-button d-flex align-items-center justify-content-center mx-auto"
                            onClick={handleGoogleSignIn}
                        >
                            <img
                                src="https://developers.google.com/identity/images/g-logo.png"
                                alt="Google logo"
                                className="google-icon me-2"
                            />
                            Continue with Google
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default LandingPage;